import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Box, Typography, Divider} from 'views/components';
import {Translate} from 'views/module';

import SlipView from './slip/SlipView';
import PaymentPlan from './payment_plan_view/PaymentPlan';
import Holidays from './holidays/Holidays';

const Payment = (props) => {
  return (
    <Stack
      sx={{
        p: 2,
      }}
      spacing={1}
    >
      <Box
        sx={{
          border: 1,
          borderColor: 'divider',
          borderRadius: 2,
          overflow: 'hidden',
        }}
      >
        <Typography
          variant='h6'
          sx={{
            pt: 2,
            pb: 1,
            px: 3,
            backgroundColor: 'grey.300',
          }}
        >
          <Translate
            expression='client.ClientDetail.Payment.PaymentPlan.Title'
          />
        </Typography>
        <Box
          sx={{
            px: 3,
            py: 2,
          }}
        >
          <PaymentPlan
            {...props}
          />
        </Box>
      </Box>
      <Box sx={{width: '100%', pt: 3, pb: 2}}>
        <Divider />
      </Box>
      <Box
        sx={{
          border: 1,
          borderColor: 'divider',
          borderRadius: 2,
          overflow: 'hidden',
        }}
      >
        <Typography
          variant='h6'
          sx={{
            pt: 2,
            pb: 1,
            px: 3,
            backgroundColor: 'grey.300',
          }}
        >
          <Translate
            expression='client.ClientDetail.Payment.PaymentSlip.Title'
          />
        </Typography>
        <Box
          sx={{
          }}
        >
          <SlipView
            {...props}
          />
        </Box>
      </Box>
      <Box sx={{width: '100%', pt: 3, pb: 2}}>
        <Divider />
      </Box>
      <Box
        sx={{
          border: 1,
          borderColor: 'divider',
          borderRadius: 2,
          overflow: 'hidden',
        }}
      >
        <Typography
          variant='h6'
          sx={{
            pt: 2,
            pb: 1,
            px: 3,
            backgroundColor: 'grey.300',
          }}
        >
          <Translate
            expression='client.ClientDetail.Payment.Holidays.Title'
          />
        </Typography>
        <Holidays />
      </Box>
    </Stack>
  );
};

Payment.propTypes = {
  refresh: PropTypes.number.isRequired,
  clientRn: PropTypes.string.isRequired,
  clientBackend: PropTypes.object.isRequired,
  clientPaymentSlipWeekly: PropTypes.array.isRequired,
  clientPaymentSlipMonthly: PropTypes.array.isRequired,
  clientPaymentSlipLoading: PropTypes.bool.isRequired,
  clientPaymentPlan: PropTypes.object,
  clientPaymentPlanLoading: PropTypes.bool.isRequired,
};
export default React.memo(Payment);
